var map = {
	"./azzaro.png": 2901,
	"./billie_eilish.png": 414,
	"./britney_spears.png": 3492,
	"./burberry.png": 3651,
	"./bvlgari.png": 6099,
	"./calvin_klein.png": 8487,
	"./davidoff.png": 6259,
	"./dolce_&_gabbana.png": 9301,
	"./giorgio_armani.png": 7595,
	"./hermes.png": 4816,
	"./hugo_boss.png": 5281,
	"./jean_paul_gaultier.png": 3603,
	"./katy_perry.png": 6444,
	"./lacoste.png": 2207,
	"./le_labo.png": 5488,
	"./loewe.png": 4908,
	"./marc_jacobs.png": 8878,
	"./montblanc.png": 400,
	"./moschino.png": 776,
	"./nautica.png": 1053,
	"./tom_ford.png": 3598,
	"./valentino.png": 16,
	"./versace.png": 763,
	"./viktor_&_rolf.png": 7826
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3393;